<template>
  <div class="error404">
    <figure class="broken-pencil">
      <BrokenPencil />
    </figure>
    <div class="message">
      <h3>Sorry, that page could not be found.</h3>
      <button class="btn btn-lg btn-primary" @click="() => useAuthenticationStore().pushRoute('/')">
        Back to PTC Wizard home
      </button>
    </div>
  </div>
</template>

<script setup>
import BrokenPencil from "@/assets/broken-pencil.svg";
import { useAuthenticationStore } from "@/stores/authentication";
</script>
